export const CreateProjectHeadConstants = [
  {
    id: 0,
    title: <>Name Your AI Agent 🪪</>,
    description: (
      <>
        Give your AI agent a name. This is the name customers will see when your
        <br /> AI Agent responds. For example: “Support Bot” or “Sales Assistant.”
      </>
    ),
  },
  {
    id: 1,
    title: <>Train Your AI Agent 📚</>,
    description: (
      <>
        Your AI can only answer questions if it knows the answers!
        <br /> Here’s how to feed it info:
      </>
    ),
  },
  {
    id: 2,
    title: <>Choose how you’d like to set up the system prompt for your AI Agent 🤖</>,
    description: '',
  },
  {
    id: 3,
    title: <>write the system prompt 💻</>,
    description: (
      <>
        Enter the instructions that will guide your AI Agent’s behavior, tone,
        <br /> and responses. You can start by selecting a template below.
      </>
    ),
  },
  {
    id: 4,
    title: <>Choose Your AI Agent’s Role 💼</>,
    description: <>Assign your AI a primary role.</>,
  },
  {
    id: 5,
    title: <>Give Your AI Voice 📣</>,
    description: <>Decide how your AI Agent should sound in conversations.</>,
  },
  {
    id: 6,
    title: <>Set Escalation Workflow 🔀</>,
    description: <>Decide how your AI should handle unanswered questions.</>,
  },
  {
    id: 6,
    title: <>Custom Workflows 🔀</>,
    description: (
      <>
        Workflows tell your AI what to do in specific situations. Click Add
        <br /> Workflow to create one, or skip and complete setup with Finish Setup.
      </>
    ),
  },
];
